import { useState } from "react";

import { NativeStackNavigationOptions } from "@react-navigation/native-stack";
import {
  Keyboard,
  SafeAreaView,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import { useTailwind } from "tailwind-rn";

import PhoneAndCountry from "./components/PhoneAndCountry";
import PhoneButton from "./components/PhoneButton";
import { KeyboardAwareView } from "../../../../components";
import TextButton from "../../components/TextButton";
import useLogin from "../../contexts/LoginContext";
import LoginHeader from "../../navigation/LoginHeader";
import { loginRoutes, LoginScreenProps } from "../../navigation/types";

export const phoneScreenOptions: NativeStackNavigationOptions = {
  header: () => <LoginHeader title="Inicia sesión en Cuanto" disableBorder />,
};

type Props = LoginScreenProps<typeof loginRoutes.phone>;
export default function PhoneScreen({ navigation }: Props) {
  const [phone, setPhone] = useState("");

  const { country, createLoginCode, onAskForHelp, onError } = useLogin();

  const [loading, setLoading] = useState(false);

  const countryCode = country.code;

  const createLoginCodeAndNavigate = async () => {
    try {
      setLoading(true);
      await createLoginCode(countryCode, phone);
      navigation.navigate(loginRoutes.code);
    } catch (e) {
      onError(e);
    } finally {
      setLoading(false);
    }
  };

  const askForHelp = async () => {
    try {
      onAskForHelp(
        "Hola! Necesito ayuda iniciando sesión. Perdí acceso a mi número anterior."
      );
    } catch (e) {
      onError(e);
    }
  };

  const tailwind = useTailwind();

  return (
    <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
      <SafeAreaView style={tailwind("flex-1")}>
        <KeyboardAwareView style={tailwind("justify-between m-4")}>
          <View>
            <PhoneAndCountry
              country={country}
              phone={phone}
              setPhone={setPhone}
            />

            <TextButton
              text="Perdí acceso a mi número anterior"
              onPress={askForHelp}
            />
          </View>

          <PhoneButton
            countryCode={countryCode}
            phone={phone}
            onPress={createLoginCodeAndNavigate}
            loading={loading}
          />
        </KeyboardAwareView>
      </SafeAreaView>
    </TouchableWithoutFeedback>
  );
}
